import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import pathToRegexp from 'path-to-regexp'
import PropTypes from 'prop-types'

import { getMenuItems } from './data/menu.data'
import NavTooltip from './tooltip/tooltip.component'

import './navigation.component.scss'

/**
 * Navigation Component
 */
class Navigation extends Component {
  /**
   * Toggle navigation
   * Logic and state handled by parent component
   */
  toggleNav = (event, expand) => {
    const { onNavigationToggle } = this.props
    onNavigationToggle(event, expand)
  }

  /**
   * Check if menu item is active
   * @param menuItem
   * @return {Array.<T>|boolean}
   */
  isActivePage (menuItem) {
    const { history } = this.props
    const currentPath = history.location.pathname
    const patterns = menuItem.pattern || menuItem.path
    let result = false;

    [].concat(patterns).forEach((pattern) => {
      const re = pathToRegexp(pattern)
      const match = re.exec(currentPath)

      if (match) {
        result = match
      }
    })

    return result
  }

  /**
   * Render Navigation
   * @returns {XML}
   */
  render () {
    const { navigationExpanded } = this.props
    const items = getMenuItems().map((item) => item)

    return (
      <div className={`app-nav ${navigationExpanded ? 'app-nav--expanded' : ''}`}>
        <div className='app-nav_mask' onClick={this.toggleNav} />
        <div className='app-nav_drawer'>
          <nav className='app-nav_menu'>
            <div className='app-nav_menu-header' onClick={this.toggleNav}>
              <i className='app-nav_menu-header_toggle q4i-hamburger-desktop-2pt' />
              <i className='app-nav_menu-header_logo q4i-logo' />
              <i className='app-nav_menu-header_chevron q4i-caret-sm-left-4pt' />
            </div>
            {(items || []).map((item) => {
              const { key, path } = item
              return (
                <Link
                  id={key}
                  key={key}
                  to={path}
                  onClick={(e) => this.toggleNav(e, false)}
                  className={`app-nav_menu-item ${this.isActivePage(item) ? 'app-nav_menu-item--active' : ''}`}>
                  {!navigationExpanded
                    ? <NavTooltip title={item.title}>
                      <i className={`app-nav_menu-item_icon ${item.icon}`} />
                    </NavTooltip>
                    : <i className={`app-nav_menu-item_icon ${item.icon}`} />}
                  <div className='app-nav_menu-item_label'>{item.title}</div>
                </Link>
              )
            })}
          </nav>
        </div>
      </div>
    )
  }
}

Navigation.propTypes = {
  navigationExpanded: PropTypes.bool,
  onNavigationToggle: PropTypes.func.isRequired
}

Navigation.defaultProps = {
  navigationExpanded: false
}

export default withRouter(Navigation)
